import { useMemo, useState } from 'react';
import LoaderContext from 'features/client/contexts/LoaderContext';
import StyledSplashScreen from 'common/components/atoms/StyledSplashScreen';
import MOLoader from 'common/components/atoms/MOLoader';

const SPINNER_SIZE = 125;

interface ILoader {
  children: React.ReactNode
}

const Loader: React.FC<ILoader> = ({ children }) => {
  const [loadingArr, setLoadingArr] = useState<boolean[]>([]);
  const value = useMemo(() => ({
    loading: !!loadingArr.length,
    setLoading: (loadingBool: boolean) => setLoadingArr((prevState: boolean[]) => {
      return loadingBool
        ? [...prevState, true]
        : prevState.slice(0, -1);
    }),
  }), [loadingArr]);

  return (
    <LoaderContext.Provider {...{ value }}>
      <StyledSplashScreen isVisible={value.loading} className="loader">
        <MOLoader size={'l'} />
      </StyledSplashScreen>
      {children}
    </LoaderContext.Provider>
  );
};

export default Loader;
